export default "__VITE_ASSET__DWT5ebNF__"